import o from "react";
import d from "hoist-non-react-statics";
import { u as c } from "./ThemeProvider--i7ESlT5.es.js";
const w = (e) => {
  const m = ({ forwardedRef: r, ...a }) => {
    const s = c();
    return /* @__PURE__ */ o.createElement(e, { ...a, ref: r, theme: s });
  }, f = (r, a) => /* @__PURE__ */ o.createElement(m, { ...r, forwardedRef: a }), t = o.forwardRef(f);
  return t.displayName = `WithTheme(${e.displayName || e.name || "Component"})`, d(t, e), t;
};
export {
  w
};
